import { useEffect, useRef, useState } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { useGetUserCashbackHistory } from './UserDetailapi';
import { Search, ArrowUp, ArrowDown, Copy, Check, ExternalLink } from 'lucide-react';
import { useDebounce } from '../../hooks/debounce';
import { useNavigate, useParams } from 'react-router-dom';
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useModalContext } from '../../contexts/ModalContext';
import { useToast } from '../../hooks/usetoast';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';
import { transactionurl } from '../../lib/transactionurl';

function UserCashbackHistory() {
    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(10);
    const [search, setSearch] = useState("");
    const [sortOrder, setSortOrder] = useState("desc")
    const [filterType, setFilterType] = useState("all")
    const [selectedLevel, setSelectedLevel] = useState("");
    const [userEmail, setUserEmail] = useState(false);
    const [referralEmail, setReferralEmail] = useState(false);
    const [double, setDouble] = useState(false);
    const searchText = useDebounce(search);
    const { id, level, type } = useParams();
    const { theme } = useModalContext()
    const toast = useToast();
    const navigate = useNavigate();
    const inputRef = useRef(null);

    useEffect(() => {
        if (level !== undefined) {
            setSelectedLevel(level);
            setFilterType("Level");
        }
    }, [level]);

    const { data: getCashbackHistory, isLoading } = useGetUserCashbackHistory({
        id,
        userId: id,
        page: searchText ? 0 : Math.max(tempPage, 0),
        searchText,
        level: filterType === "Level" ? selectedLevel : undefined,
        type: type,
        sortField: "createdAt",
        size: tempRows,
        sortOrder: sortOrder
    })




    const totalRecords = getCashbackHistory?.data?.total || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(Math.max(page, 0));
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    useEffect(() => {
    }, [filterType, selectedLevel]);


    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    const renderCopyIcon = (isCopied, onClick, theme) => (
        isCopied ?
            <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : "black" }} />
            :
            <Copy onClick={onClick} size={20} className="ml-5" style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : "black" }} />
    );

    const copytxnhashAddress = async data => {
        setDouble(data._id)
        await copyToClipboard(data)
        toast.success("Copied")
        setTimeout(() => {
            setDouble()
        }, 800)
    }


    const renderTransactionLink = (hash, urlPrefix, isCopied, onClickCopy, theme) => (
        hash ? (
            <>
                {`${hash.slice(0, 3)}...${hash.slice(-3)}`}
                {renderCopyIcon(isCopied, onClickCopy, theme)}
                <a href={urlPrefix + hash} target="_blank" rel="noopener noreferrer" className="ml-2">
                    <ExternalLink style={{ marginLeft: "5px" }} size={20} />
                </a>
            </>
        ) : "-"
    );

    const copyUserEmailAddress = async data => {
        setUserEmail(data._id)
        await copyToClipboard(data?.userId?.email)
        toast.success("Copied")
        setTimeout(() => {
            setUserEmail()
        }, 800)
    }

    const copyReferralEmailAddress = async data => {
        setReferralEmail(data._id)
        await copyToClipboard(data?.referUserId?.email)
        toast.success("Copied")
        setTimeout(() => {
            setReferralEmail()
        }, 800)
    }




    const renderCashbackHistory = () => (
        getCashbackHistory?.data?.data?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="Referral transaction history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='text-nowrap' align="center">S.NO</TableCell>
                                    <TableCell className='text-nowrap' align="center">User Level</TableCell>
                                    <TableCell className='text-nowrap' align="center">Referrer Email</TableCell>
                                    <TableCell className='text-nowrap' align="center">User Email</TableCell>
                                    <TableCell className='text-nowrap' align="center">From User Hash</TableCell>
                                    <TableCell className='text-nowrap' align="center">To User Hash</TableCell>
                                    <TableCell className='text-nowrap' align="center">Reward Amount</TableCell>
                                    <TableCell className='text-nowrap' align="center">Reward Status</TableCell>

                                    <TableCell className='text-nowrap' align="center">
                                        Date & Time{' '}
                                        {sortOrder !== 'desc' ? (
                                            <ArrowUp
                                                onClick={() => setSortOrder('desc')}
                                                style={{ cursor: 'pointer' }}
                                                aria-label="Sort descending"
                                            />
                                        ) : (
                                            <ArrowDown
                                                onClick={() => setSortOrder('asc')}
                                                style={{ cursor: 'pointer' }}
                                                aria-label="Sort ascending"
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getCashbackHistory?.data?.data?.map((row, i) => (
                                    <TableRow key={row?._id || i}>
                                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell>{row.userLevel}</TableCell>
                                        <TableCell align="center">
                                            {row?.userId?.email || "admin@roupay.com"}
                                            {userEmail === row._id ? (
                                                <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : 'black' }} />
                                            ) : (
                                                <Copy
                                                    onClick={() => copyUserEmailAddress(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : 'black' }}
                                                />
                                            )}
                                        </TableCell>

                                        <TableCell align="center">
                                            {row?.referUserId?.email || "-"}
                                            {referralEmail === row._id ? (
                                                <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : 'black' }} />
                                            ) : (
                                                <Copy
                                                    onClick={() => copyReferralEmailAddress(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : 'black' }}
                                                />
                                            )}
                                        </TableCell>

                                        <TableCell align="center">
                                            {renderTransactionLink(row.fromTxnHash, transactionurl["POL"], double === row._id, () => copytxnhashAddress(row.fromTxnHash), theme)}
                                        </TableCell>


                                        <TableCell align="center">
                                            {renderTransactionLink(row.fromTxnHash, transactionurl["POL"], double === row._id, () => copytxnhashAddress(row.fromTxnHash), theme)}
                                        </TableCell>

                                        <TableCell className="text-nowrap" align="center">
                                            {row?.rewardAmount ? (
                                                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                    {row.rewardAmount}
                                                    {row?.currencyImage && (
                                                        <img
                                                            src={row.currencyImage}
                                                            alt="Currency Icon"
                                                            style={{
                                                                height: '20px',
                                                                width: '20px',
                                                                borderRadius: '50%',
                                                                verticalAlign: 'middle',
                                                                objectFit: 'cover',
                                                            }}
                                                        />
                                                    )}
                                                </span>
                                            ) : (
                                                '-'
                                            )}
                                        </TableCell>
                                        {
                                            row?.rewardStatus == "Completed" ?
                                                <TableCell align="center" className=' text-success'>{row?.rewardStatus || "-"}</TableCell>
                                                :
                                                <TableCell align="center" className=' text-danger'>{row?.rewardStatus || "-"}</TableCell>


                                        }
                                        <TableCell align="center">
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        ) : (
            <NoRecords />
        )
    );


    return (
        <section>
            <h4>Cashback History</h4>
            <div className="ad_pg_bx bg-white p-3">
                <div className='d-flex justify-content-between align-items-center mb-2'>
                    <div className='col-md-4'>
                        <div className="input-group">
                            <span className="input-group-icon">
                                <Search size={20} color='#aaa9a9' />
                            </span>
                            <input
                                type="text"
                                ref={inputRef}
                                onChange={(e) => setSearch(e.target.value)}
                                className="form-control"
                                placeholder="Search Name"
                            />
                        </div>
                    </div>
                    <div className='d-flex col-md-4 justify-content-end'>
                        <select
                            className="form-select me-2"
                            value={selectedLevel}
                            onChange={(e) => {
                                const value = e.target.value;
                                setSelectedLevel(value);
                                setFilterType(value === "" ? "all" : "Level");
                                setTempPage(0);
                            }}
                        >
                            <option value="">All Levels</option>
                            {[...Array(10)].map((_, i) => {
                                const apiLevel = i;
                                const displayLevel = apiLevel + 1;
                                return (
                                    <option key={apiLevel} value={apiLevel}>
                                        {displayLevel === 1 ? "Direct" : `Level ${displayLevel}`}
                                    </option>
                                );
                            })}
                        </select>

                        <button
                            className="btn btn-outline-secondary"
                            onClick={() => {
                                setSearch("");
                                setFilterType("all")
                                setSelectedLevel("");
                                if (inputRef.current) inputRef.current.value = "";
                            }}
                        >
                            Clear Filters
                        </button>
                        <button
                            className="btn btn-outline-primary ms-2"
                            onClick={() => {
                                navigate(`/SingleUserHistory/${id}`, { state: { lastActiveTab: "Referral" } });
                            }}
                        >
                            Back
                        </button>
                    </div>
                </div>
                {(searchText || selectedLevel) && (
                    <div className="mb-2">
                        <strong>Active Filters:</strong>
                        {searchText && <span className="badge bg-primary ms-2">Search: {searchText}</span>}
                        {selectedLevel && (
                            <span className="badge bg-success ms-2">
                                {parseInt(selectedLevel) + 1 === 1
                                    ? "Direct"
                                    : `Level ${parseInt(selectedLevel) + 1}`}
                            </span>
                        )}
                    </div>
                )}
                {isLoading ?
                    <PageLoader />
                    :
                    renderCashbackHistory()
                }
            </div>
        </section>
    )
}

export default UserCashbackHistory